import { useState } from "react";
import type { MessageContextType } from "@dugads/shared";
import { Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SendMessageDialog } from "@/components/send-message-dialog";

interface SendMessageButtonProps {
  contextType: MessageContextType;
  contextId: string;
  contextLabel: string;
  /** School ID -- required for sport context */
  schoolId?: string;
  /** Variant -- "ghost" for row actions, "outline" for header buttons */
  variant?: "ghost" | "outline";
  /** Show text label alongside icon */
  showLabel?: boolean;
}

export function SendMessageButton({
  contextType,
  contextId,
  contextLabel,
  schoolId,
  variant = "ghost",
  showLabel = false,
}: SendMessageButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant={variant}
        size="sm"
        onClick={() => setOpen(true)}
        title="Broadcast message to group"
        data-action="send-message"
        data-context-type={contextType}
        data-context-id={contextId}
      >
        <Megaphone className="h-4 w-4" />
        {showLabel && <span className="ml-2 hidden sm:inline">Send Message</span>}
      </Button>
      {open && (
        <SendMessageDialog
          contextType={contextType}
          contextId={contextId}
          contextLabel={contextLabel}
          schoolId={schoolId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
